var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.acceptedCookies)?_c('div',{staticClass:"cookie"},[_c('p',[_vm._v("We use cookies to give you the best experience. A lot of our website couldn't function without cookies. If you have any issues, please notify us.")]),_c('button',{attrs:{"type":"button"},on:{"click":_vm.acceptCookie}},[_vm._v("I accept")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }